<template>
<div class="image-page">
  <div id="viewer"></div>
  <transition name="fade">
    <div class="note" v-if="showNote">
      <img src="@/assets/360-note.svg" />
      <div class="text">{{ $t('poi.360Info') }}</div>
    </div>
  </transition>
</div>
</template>

<script>
import PhotoSphereViewer from 'photo-sphere-viewer'
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'

export default {
  data () {
    return {
      showNote: false,
      currentEnv: null
    }
  },
  created () {
    const currentEnv = window.__wxjs_environment === 'miniprogram' || /miniProgram/i.test(navigator.userAgent.toLowerCase())
    if (!currentEnv) document.title = this.$route.query.name
    this.currentEnv = currentEnv
  },
  mounted () {
    const viewer = new PhotoSphereViewer({
      container: 'viewer',
      loading_txt: this.$t('common.imgLoading'),
      panorama: this.$route.query.url,
      time_anim: false,
      navbar: false,
      default_fov: 179
    })
    viewer.on('ready', () => {
      const showNote = window.localStorage.getItem('showNote')
      if (!showNote) {
        this.showNote = true
        window.localStorage.setItem('showNote', 1)
      } else {
        this.showNote = false
      }
    })

    viewer.on('position-updated', () => {
      if (this.showNote) {
        this.showNote = false
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.image-page {
  position: relative;

  .note {
    position: absolute;
    top: 168px;
    left: 50%;
    width: 180px;
    padding: 26px 0 22px;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.65);
    transform: translate(-50%, 0);
    z-index: 10;

    img {
      display: block;
      margin: 0 auto;
      width: 91px;
    }

    .text {
      text-align: center;
      font-size: 16px;
      line-height: 22px;
      margin-top: 17px;
      color: #ffffff;
      font-weight: bold;
      font-family: GothamBold;
    }
  }

  #viewer {
    width: 100%;
    height: 100vh;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
